import { IFlowChar } from '@/typings/home'
import { STATUS_CONSTANT } from '@/typings/common'

export const flowChartList: IFlowChar[] = [
  {
    path: require('../../../assets/images/home/flow/user.png'),
    text: '注册账号',
    flag: STATUS_CONSTANT.STATUS_01
  },
  {
    path: require('../../../assets/images/home/flow/register.png'),
    text: '登录账号',
    flag: STATUS_CONSTANT.STATUS_02
  },
  {
    path: require('../../../assets/images/home/flow/meeting.png'),
    text: '报名会议',
    flag: STATUS_CONSTANT.STATUS_03
  },
  {
    path: require('../../../assets/images/home/flow/company.png'),
    text: '企业信息',
    flag: STATUS_CONSTANT.STATUS_04
  },
  {
    path: require('../../../assets/images/home/flow/person.png'),
    text: '人员信息',
    flag: STATUS_CONSTANT.STATUS_05
  },
  {
    path: require('../../../assets/images/home/flow/invoice.png'),
    text: '发票信息',
    flag: STATUS_CONSTANT.STATUS_06
  },
  {
    path: require('../../../assets/images/home/flow/success.png'),
    text: '报名成功',
    flag: STATUS_CONSTANT.STATUS_07
  }
]
